export default __webpack_public_path__ + "static/media/4_center.0aac174c.png";